export const transactionUserConstants = {
  TRANSTATION_LIST_USER: "TRANSTATION_LIST_USER",
};
